<template>
    <div class="zlicon">
      <div class="account_set_header">
        <h2 :style="{color: iconColor }">icon图标</h2>
        <span  class="iconSet">
          <el-color-picker v-model="iconColor"></el-color-picker>
          <span style="font-size: 12px;" :style="{color: iconColor }">切换颜色试一试</span>
          <el-button style="margin-left: 30px;" :style="{background: iconColor }" size="mini" type="primary" @click="dialogVisible = true">如何使用？</el-button>
        </span>
      </div>
      <div style="margin-top: 14px;">
        使用iconfont.js
      </div>
      <ul class="iconBox">
        <li v-for="(item,index) in iconList" :key="index" :title="item.icon" @click="copyContent(item.icon)">
          <svg
                 style="width: 30px; height: 30px; vertical-align: -0.15em"
                 class="icon svg-icon"
                 aria-hidden="true" slot="reference"
                 :fill="iconColor"
               >
            <use :xlink:href="'#'+ item.icon"></use>
          </svg>
        </li>
      </ul>
      <div style="margin-top: 14px;">
        使用iconfont.css
      </div>
      <ul class="iconBox">
        <li v-for="(item,index) in iconClassList" :key="index" :title="item.icon" @click="copyContent(item.icon)">
          <span class="iconfont" :class="item.icon" style="font-size: 30px"/>
        </li>
      </ul>
      <div style="margin-top: 14px;">
        使用element/icon
      </div>
      <ul class="iconBox">
        <li><a href="https://element.eleme.cn/#/zh-CN/component/icon" target="_blank">https://element.eleme.cn/#/zh-CN/component/icon</a></li>
      </ul>

      <!-- https://element.eleme.cn/#/zh-CN/component/icon -->
      <el-dialog
        title="有两种方法"
        :visible.sync="dialogVisible">
         <div style="margin: 10px 0;"> 鼠标点击图标，即可复制class名称</div>
         <div style="margin: 10px 0;">第一种：使用iconfont.js
           <json-viewer
             style="line-height: 1.4;"
             :value="iconCode"
             copyable
             boxed
             sort
           ></json-viewer>
         </div>
        <div style="margin: 10px 0;">第二种：使用iconfont.css
          <json-viewer
            style="line-height: 1.4;"
            :value="iconStyle"
            copyable
            boxed
            sort
          ></json-viewer>
        </div>
        <p style="color: red">注意复制后，要去掉引号！</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  /*
   *  中联图标库  2022、12、1
   *  author: wjl
   */
    export default {
        name: "zlicon",
       data(){
          return {
            dialogVisible: false,
            iconColor: '#409EFF',
            iconList:[
              { icon:'icon-ppt' },
              { icon:'icon-tianjiappt' },
              { icon:'icon-link' },
              { icon:'icon-shixun' },
              { icon:'icon-tianjiashixun' },
              { icon:'icon-buzhou' },
              { icon:'icon-daan' },
              { icon:'icon-taolun' },
              { icon:'icon-pingfen' },
              { icon:'icon-tiwen' },
              { icon:'icon-biji' },
              { icon:'icon-dianzan' },
              { icon:'icon-liulan' },
              { icon:'icon-xiaoxi' },
              { icon:'icon-xiugai' },
              { icon:'icon-a-kechengziyuan2x' },
              { icon:'icon-a-chengjipingjia2x' },
              { icon:'icon-a-tongji2x' },
              { icon:'icon-a-cepingceyan2x' },
              { icon:'icon-a-banjishezhi2x' },
              { icon:'icon-a-kechengbiji2x' },
              { icon:'icon-a-kehouzuoye2x' },
              { icon:'icon-a-shijianjiaoxue2x' },
              { icon:'icon-a-taolun2x' },
              { icon:'icon-a-2xjiaoxueneirong' },
              { icon:'icon-a-banjitongzhi2x' },
              { icon:'icon-xueyuanguanli' },
              { icon:'icon-monikaoshi' },
              { icon:'icon-banshujilu' },
              { icon:'icon-jilifankui' },
              { icon:'icon-shijuanziyuansvg' },
              { icon:'icon-ziyoulianxi' },
              { icon:'icon-paiming' },
              { icon:'icon-dasuolvetuliebiao' },
              { icon:'icon-danlieliebiao' },
            ],
            iconClassList: [
              { icon:'iconasset_pledge' },
              { icon:'iconasset_storage' },
              { icon:'iconasset_outbound' },
              { icon:'iconpledge_transfer' },
              { icon:'iconasset_list' },
              { icon:'iconasset_decommissioning' },
              { icon:'iconaudit_task' },
              { icon:'iconwms_storage' },
              { icon:'iconwms_out_of_the_library' },
              { icon:'iconshipper_information' },
              { icon:'iconcustomer_relationship_maintenance' },
              { icon:'iconsearch' },
              { icon:'iconorder_list' },
              { icon:'iconskinning' },
              { icon:'iconhelp' },
              { icon:'iconchange_password' },
              { icon:'icondrop_out' },
              { icon:'iconprevious' },
              { icon:'iconnext_step' },
              { icon:'iconshut_down' },
              { icon:'iconmine' },
              { icon:'iconmessage' },
              { icon:'icongo_to_the_home' },
              { icon:'iconprevious_page' },
              { icon:'iconnext_page' },
              { icon:'iconend_page' },
              { icon:'iconsuspension_off' },
              { icon:'iconuser_management' },
              { icon:'icondepartment_management' },
              { icon:'iconrole_management' },
              { icon:'iconmenu_management' },
              { icon:'iconmovable_user_behavior' },
              { icon:'icondictionary_management' },
              { icon:'iconuser_behavior_log' },
              { icon:'iconuser_statistics' },
              { icon:'icondecommission_review' },
              { icon:'icon-dasuolvetuliebiao' },
              { icon:'icon-danlieliebiao' },
            ],
            iconCode:  `
                    <svg
                         style="width: 30px; height: 30px;"
                         class="icon svg-icon"
                         aria-hidden="true"
                         >
                         <use xlink:href="输入复制的class名称"></use>
                     </svg>
                     // 修改样式
                      svg{
                            fill: '#000000'
                      }
            `,
            iconStyle: `
                <span class="icon iconfont 输入复制的class名称"></span>
                  // 修改样式
                 .输入复制的class名称:before {
                    content: "\\e602";
                  }
            `,
        }
     },
      methods: {
        copyContent(value, type = 'input') {
          const input = document.createElement(type);
          input.setAttribute('readonly', 'readonly'); // 设置为只读, 防止在 ios 下拉起键盘
          // input.setAttribute('value', value); // textarea 不能用此方式赋值, 否则无法复制内容
          input.value = value;
          document.body.appendChild(input);
          input.setSelectionRange(0, 9999); // 防止 ios 下没有全选内容而无法复制
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          this.$messageSuccess('已复制到剪贴板：' + value)
      },
    }

  }
</script>

<style scoped lang="scss">
.zlicon{
  height: 100%;
  margin-right: 15px;
  .account_set_header {
    height: 60px;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2{
      font-size: 20px;
      font-weight: 600;
      color: #0F0D11;
      position: relative;
      padding-left: 20px;
      &::after{
        content: "";
        position: absolute;
        width: 4px;
        height: 24px;
        background: #1890FF;
        border-radius: 0px 7px 7px 0px;
        left: 0;
    }
  }
  }
  .iconSet{
    height: 40px;
    display: flex;
    align-items: center;
  }
  .iconBox{
    /*height: calc(100% - 75px);*/
    /*overflow: auto;*/
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    background: #ffffff;
    li{
      margin: 15px;
      cursor: pointer;
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/zlicon.vue